var map = {
	"./number-1.svg": 782,
	"./number-2.svg": 783,
	"./number-3.svg": 784,
	"./number-4.svg": 785,
	"./number-5.svg": 786,
	"./number-6.svg": 787,
	"./number-7.svg": 788,
	"./number-8.svg": 789,
	"./number-9.svg": 790,
	"./number-shine-1.svg": 791,
	"./number-shine-2.svg": 792,
	"./number-shine-3.svg": 793,
	"./number-shine-4.svg": 794,
	"./number-shine-5.svg": 795,
	"./number-shine-6.svg": 796,
	"./number-shine-7.svg": 797,
	"./number-shine-8.svg": 798,
	"./number-shine-9.svg": 799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 781;